export const eventJournalSortStorageKey = 'event_journal_sort';
